<template>
  <div class="disclaimer">
    <div class="card">
      <div v-if="cancel" class="right_top" @click="close">
        <i class="el-icon-close"></i>
      </div>
      <div>
        <span style="font-weight: 900; font-size: 24px"> 温馨提示 </span>
      </div>
      <div class="row" style="text-align: left; font-size: 18px;">
        <span style="line-height: 30px">
          尊敬的用户您好！请您先完成注册流程，再使用优行关爱小助手哦。
        </span>
      </div>
      <div class="row">
        <span class="button" @click="clickButton">返回</span>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "GuidancePage",
  props: {
    // 点击按钮后的方法
    confirm: {
      type: Function,
      default: null,
    },
    // 点击叉叉后的方法
    cancel: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {};
  },
  methods: {
    clickButton() {
      //
      if (this.cancel) {
        this.cancel();
      } else {
        try {
          // eslint-disable-next-line no-undef
          WeixinJSBridge.call('closeWindow');
        } catch (e) {
          console.log(e);
        }
      }
    },
    close() {
      if (this.cancel) this.cancel();
    },
  },
};
</script>

<style scoped>
.disclaimer {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  text-align: center;
  background-color: #c9c9c9;
  overflow: hidden;
}

/* 卡片式UI */
.card {
  position: relative;
  width: 240px;
  padding: 35px;
  margin-top: 80px;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.row {
  margin-top: 20px;
}

.button {
  display: inline-block;
  text-align: center;
  color: #fff;
  background-color: #d72618;
  border-radius: 20px;
  padding: 10px 20px 10px 20px;
  font-size: 16px;
  line-height: 20px;
  cursor: pointer;
  text-decoration: none;
}

.button:hover {
  background-color: #c11b0f;
}

.right_top {
  position: absolute;
  top: 18px;
  right: 18px;
  transform: scale(2, 2);
  color: #bfbfbf;
}
</style>
